const images = {};
document.querySelectorAll("img").forEach(e => images[e.id] = e);

export default {
    image(id: string) {
        return images[id];
    },
};